import { render, staticRenderFns } from "./CORequestDetailModal.vue?vue&type=template&id=3b49bc2c&"
import script from "./CORequestDetailModal.vue?vue&type=script&lang=js&"
export * from "./CORequestDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports